import { render, staticRenderFns } from "./tabsCommon.vue?vue&type=template&id=a0a82ea2"
import script from "./tabsCommon.vue?vue&type=script&lang=js"
export * from "./tabsCommon.vue?vue&type=script&lang=js"
import style0 from "./tabsCommon.vue?vue&type=style&index=0&id=a0a82ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports